import types from "../../../constants/action-types";
import { AES, enc } from "crypto-js";

const secretName = "premiumsoft-admin-panel";

const decryptData = (data, secret) => {
  try {
    let bytes = AES.decrypt(data, secret);
    return bytes.toString(enc.Utf8) || data;
  } catch (error) {
    return data;
  }
};

let role = localStorage.getItem("role") || "";
let token = localStorage.getItem("premiumsoft_access_token");
const defaultState = {
  token: token ? token : null,
  role: decryptData(role, secretName),
  username: localStorage.getItem("username"),
  permissions: "",
};

const map = {
  [types.SET_TOKEN]: (state, { payload }) => ({
    ...state,
    token: payload,
  }),
  [types.SET_PERMISSIONS]: (state, { payload }) => ({
    ...state,
    permissions: payload,
  }),
  [types.SET_ROLE]: (state, { payload }) => ({
    ...state,
    role: payload,
  }),
  [types.SET_USERNAME]: (state, { payload }) => ({
    ...state,
    username: payload,
  }),
  [types.CLEAR_TOKEN]: (state) => ({
    ...state,
    token: null,
  }),
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) =>
  (map[action.type] && map[action.type](state, action)) ||
  state ||
  defaultState;
